export default __webpack_public_path__ + "static/media/planet-earth.faacb211.jpg";